import { getObjectKeys } from "../validators/validators";

const useInputChange = (input, setInput, error, setError) => {
  const handleChange = (e) => {
    let { name, value } = e.target;
    value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    // remove item from state object using key
    if (getObjectKeys(error).length !== 0) {
      setError((current) => {
        const copy = { ...current };
        delete copy[name];
        delete copy["start_date"];
        return copy;
      });
    }

    // if(name == 'start_date' || name == 'end_date'){
    //     let start_date = document.getElementById('start_date').value
    //     let end_date = document.getElementById('end_date').value
    //     let date_1 = new Date(start_date)
    //     let date_2 = new Date(end_date)
    //     const check = date_1.getDate() >= date_2.getDate()
    //     if(check){
    //       setError((state) => {
    //         return {...state, start_date: `Start date can not be greater than or equal to end date`}
    //       })
    //     }else{
    //     }
    // }

    setInput((state) => ({ ...state, [name]: value }));
  };

  return [input, handleChange];
};

export default useInputChange;
